(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sabinat-product-recommendation"]) return;
  try {
    
if (!window.sabinatKitLinkInitialized) {
  window.sabinatKitLinkInitialized = true;

  const kitMarker = document.getElementById('sabinat-kit-product-marker');
  const productTitle = document.querySelector('main h1');

  if (kitMarker && productTitle && !document.querySelector('.sabinat-product-badge--title')) {
    const badge = document.createElement('span');
    badge.className = 'sabinat-product-badge sabinat-product-badge--title';
    badge.textContent = 'Más vendido';
    productTitle.insertAdjacentElement('beforebegin', badge);
  }

  document.querySelectorAll('a').forEach((link) => {
    if (link.textContent?.trim().toLowerCase() === 'ver kit completo') {
      link.setAttribute('href', '/products/kit');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
if (!window.sabinatQuickViewInitialized) {
  window.sabinatQuickViewInitialized = true;

  document.addEventListener('click', (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const trigger = target.closest('[data-sabinat-quick-view-open]');

    if (trigger) {
      const dialog = document.getElementById(`sabinat-quick-view-${trigger.dataset.sabinatQuickViewOpen}`);

      if (dialog && !dialog.open) dialog.showModal();
      return;
    }

    if (target.matches('.sabinat-quick-view')) target.close();
  });
}

  } catch(e) { console.error(e); }
})();
})();
